import { render, staticRenderFns } from "./SummaryBrackets.vue?vue&type=template&id=6e1e9204"
import script from "./SummaryBrackets.vue?vue&type=script&lang=js"
export * from "./SummaryBrackets.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrackets.vue?vue&type=style&index=0&id=6e1e9204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports